import { Injectable } from "@angular/core";
import { Http, Headers } from "@angular/http";
import { BaseService } from "../../base.service";
import { CookieService } from "ngx-cookie-service";

@Injectable()
export class ProductSummaryService extends BaseService {
  constructor(http: Http, cookieService: CookieService) {
    super(http, cookieService);
    this.init("product-detail");
  }

  getProductDetail(filters) {
    let headers = new Headers();
    headers.append("Accept", "application/json");
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", this.getAuthToken());
    return this.http
      .post(this.baseURL(), JSON.stringify(filters), { headers: headers })
      .toPromise()
      .then(response => {
        return response.json();
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/products/product-summary/product_summary.service.ts